import type { ReactElement } from 'react';
import AlreadyAppliedDecline from '../../../pages/AlreadyAppliedDecline';
import InformationMismatch from '../../../pages/InformationMismatch';
import ScoreDecline from '../../../pages/ScoreDecline';
import { decisions } from '../../../utilities/constants';
import type { QuotationDecisionResponse } from '../../../types/api';

const getResultPage = (responseData: QuotationDecisionResponse, isObDeclineConsent?: boolean): ReactElement => {
    switch (responseData.reason) {
        case decisions.INFORMATION_MISMATCH:
            return (
                <InformationMismatch
                    title={responseData.userData.title}
                    firstName={responseData.userData.firstName}
                    lastName={responseData.userData.lastName}
                    dateOfBirth={responseData.userData.dateOfBirth}
                    employmentStatus={responseData.userData.employmentStatus}
                    occupation={responseData.userData.occupation}
                    houseFlatNameNumber={responseData.userData.houseFlatNameNumber || ''}
                    streetName={responseData.userData.streetName}
                    addressLine2={responseData.userData.addressLine2}
                    townCity={responseData.userData.townCity}
                    county={responseData.userData.county}
                    postcode={responseData.userData.postcode}
                    yearsAtAddress={responseData.userData.yearsAtAddress}
                />
            );
        case decisions.SCORE_DECLINE:
            return (
                <ScoreDecline
                    firstName={responseData.userData.firstName}
                    requoteOptIn={responseData.requoteOptIn}
                    isObDeclineConsent={isObDeclineConsent}
                />
            );

        case decisions.ALREADY_APPLIED_DECLINE:
            return <AlreadyAppliedDecline firstName={responseData.userData.firstName} />;

        default:
        case decisions.ERROR:
            throw new Error();
    }
};

export default getResultPage;
